import React from "react"
import Button from "../Button/Button"
import * as styles from "./PreviewSolution.module.css"
import useSolutionData, { getFrontmatter } from "../utils/useSolutionData"

type PreviewSolutionProps = {
  to: string
}

const PreviewSolution = ({ to }: PreviewSolutionProps) => {
  //
  const solutionsData = useSolutionData()
  const { image, title, description, link } = getFrontmatter(solutionsData, to)

  return (
    <div className={styles.container}>
      <div>
        <img src={image} alt={title} />
        <div className={styles.content}>
          <h3>{title.split(" ").slice(0, 2).join(" ")}</h3>
          <p>
            {description.length > 230
              ? `${description.slice(0, 230)}...`
              : description}
          </p>
        </div>
      </div>
      <Button link={link} underline leftResponsive>
        Read More
      </Button>
    </div>
  )
}

export default PreviewSolution
